import apiClient from "../api/apiClient";

/** CONS-5: Good Faith Estimate requests (45 CFR 149.610). */
export type GfeService = "Membership" | "OptionalVideoVisit" | "RequiredVideoVisit" | "Other";
export type GfeDelivery = "Email" | "Mail";

export interface GfeRequest {
  id: string;
  requestedAt: string;
  /** yyyy-MM-dd — three business days after the request. */
  dueBy: string;
  services: GfeService[];
  details?: string | null;
  delivery: GfeDelivery;
  answeredAt?: string | null;
  answerNote?: string | null;
  // Staff view only.
  patientId?: string | null;
  patientName?: string | null;
  answeredByName?: string | null;
}

export const GFE_SERVICE_LABELS: Record<GfeService, string> = {
  Membership: "Membership",
  OptionalVideoVisit: "Optional video consultation",
  RequiredVideoVisit: "Clinician-required video consultation",
  Other: "Something else",
};

/** "2026-10-08" → "October 8, 2026", as a calendar date (no time-zone shift). */
export const gfeDisplayDate = (iso: string) => {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
};

export const goodFaithEstimateService = {
  mine: async () => (await apiClient.get<GfeRequest[]>("/patient/good-faith-estimates")).data,
  request: async (body: { services: GfeService[]; details?: string; delivery: GfeDelivery }) =>
    (await apiClient.post<GfeRequest>("/patient/good-faith-estimates", body)).data,

  queue: async (openOnly: boolean) =>
    (await apiClient.get<GfeRequest[]>("/good-faith-estimates", { params: { openOnly } })).data,
  openCount: async () => (await apiClient.get<{ count: number }>("/good-faith-estimates/open-count")).data.count,
  answer: async (id: string, note: string) => {
    await apiClient.post(`/good-faith-estimates/${id}/answer`, { note });
  },
};
